import axios from "./http.js";

export default {
  get(url, data, config) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, data, config)
        .then((res) => resolve(res))
        .catch((error) => reject(error));
    });
  },
  post(url, data, config) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => resolve(res))
        .catch((error) => reject(error));
    });
  },
  put(url, data, config) {
    return new Promise((resolve, reject) => {
      axios
        .put(url, data, config)
        .then((res) => resolve(res))
        .catch((error) => reject(error));
    });
  },
  delete(url, data, config) {
    return new Promise((resolve, reject) => {
      axios
        .delete(url, data, config)
        .then((res) => resolve(res))
        .catch((error) => reject(error));
    });
  },
};
